import { observable, computed, action } from 'mobx';
import {
  Model,
  App,
  ArrayApp,
  ModelRegistry,
  AppRegistry,
  QueryRegistry,
  ComponentRegistry,
} from 'core/index';
import Alert from 'react-s-alert';
import i18next from 'i18next';

import { CanCreateInSpacesQuery } from 'apps/space/gql';
import { SpaceComponent } from 'apps/space/views/spaceComponent';
import { SpaceOption } from 'apps/space/views/spaceOption';
import { SpaceItem } from 'apps/space/views/spaceItem';

QueryRegistry.add('space.canCreateInSpaces', CanCreateInSpacesQuery);
ComponentRegistry.add('space.spaceComponent', SpaceComponent);
ComponentRegistry.add('space.spaceOption', SpaceOption);
ComponentRegistry.add('space.spaceItem', SpaceItem);

export class SpaceModel extends Model {
  static registryName = 'SpaceModel';
  static ModelProps = {
    parent: 'SpaceModel',
    content: 'ContentModel',
  };

  @observable spaceType;
  @observable content;
  @observable parent;
  @observable whichTypes = [];
  @observable hasPaidSubscription;
  @observable hasProSubscription;
  @observable subscriptionType;
  @observable hasBillingPermissions;
  @observable hasValidPaymentMethod;
  @observable trialPeriodEnd;
  @observable remainingSharedFiles;
  @observable flags;
  @observable projects;
  @observable sharedFiles;

  @computed get title() {
    return this.content.title;
  }

  @computed get path() {
    if (this.spaceType === 'PROFILE') {
      return `@${this.content.slug}`;
    }
    if (this.spaceType === 'INITIATIVE') {
      return `+${this.content.slug}`;
    }
    return '';
  }

  // add a property including path and title

  @computed get route() {
    if (!this.path) return {};
    const spaceType = this.spaceType.toLowerCase();
    return {
      name: spaceType,
      params: { [spaceType]: this.path },
    };
  }
}
ModelRegistry.add(SpaceModel);

export class SpaceApp extends App {
  static registryName = 'SpaceApp';
  static Model = SpaceModel;
  static AppProps = {
    parent: 'SpaceApp',
    content: 'ContentApp',
  };
}
AppRegistry.add(SpaceApp);

export class SpacesApp extends ArrayApp {
  static registryName = 'SpacesApp';
  static ElementApp = SpaceApp;

  // eslint-disable-next-line
  getDup(space) {
    // eslint-disable-next-line
    for (const s of this) {
      if (s.id === space.id) {
        return s;
      }
    }
  }

  @action Add = space => {
    const dup = this.getDup(space);
    if (dup) {
      if (dup.deleted) {
        dup.deleted = false;
      } else {
        const { path } = space;
        Alert.error(i18next.t("No need to add '{{path}}' twice!", { path }));
      }
    } else {
      this.push(space);
    }
  };

  @action Delete = space => {
    const exists = this.upstream.findIndex(s => s.id === space.id);
    if (exists === -1) {
      this.remove(space);
    } else {
      space.SetDeleted(true);
    }
  };
}
AppRegistry.add(SpacesApp);
